/**
 * Canales de flujo (doc 0438 Parte VII): WhatsApp no oficial, WhatsApp oficial y Telegram.
 * Un flujo pertenece a un canal y solo corre en conexiones de ese canal.
 *
 * WHY aquí: la interfaz razonaba en binario («¿es WABA?») con una copia de `isWaba` en cada
 * pantalla (campañas, simulador, barra del editor, paleta) y Telegram caía del lado de Baileys
 * sin que nadie lo decidiera. Es el espejo de `crm-flowbuilder/domain/FlowChannel.ts`.
 */
export const FLOW_CHANNELS = ["baileys", "waba", "telegram"];

export const FLOW_CHANNEL_META = {
  baileys: {
    label: "WhatsApp",
    long: "WhatsApp (no oficial)",
    description: "Para conexiones API Baileys: escaneas un QR con el móvil del negocio.",
    icon: "/whatsapp.png",
    color: "#25D366",
  },
  waba: {
    label: "WhatsApp oficial",
    long: "WhatsApp oficial (WABA, Meta)",
    description: "Para la API oficial de Meta: ventana de 24 h y plantillas aprobadas para escribir primero.",
    icon: "/whatsapp-api.png",
    color: "#128C7E",
  },
  telegram: {
    label: "Telegram",
    long: "Telegram (cuenta personal)",
    description: "Para una cuenta de Telegram vinculada por QR. Los botones llegan como menú numerado.",
    icon: "/telegram.png",
    color: "#229ED9",
  },
};

/** Canal guardado en un flujo; vacío o desconocido se lee `baileys` (el valor por defecto de la columna). */
export const channelOfFlow = (provider) => (FLOW_CHANNELS.includes(provider) ? provider : "baileys");

/** Proveedores que NO ejecutan flujos (doc 0445 E5): el correo no es una conversación de menús. */
export const PROVIDERS_WITHOUT_FLOWS = ["email"];

/** Canal de flujo que admite una conexión según su `provider`; null si no admite flujos. Facebook e Instagram, como hasta ahora: baileys. */
export function flowChannelOf(connectionProvider) {
  const p = String(connectionProvider || "").trim().toLowerCase();
  if (PROVIDERS_WITHOUT_FLOWS.includes(p)) return null;
  if (p === "waba") return "waba";
  if (p === "telegram_user") return "telegram";
  return "baileys";
}

export const flowFitsConnection = (flowProvider, connectionProvider) => {
  const canal = flowChannelOf(connectionProvider);
  return canal !== null && channelOfFlow(flowProvider) === canal;
};
